import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { registerLicense } from '@syncfusion/ej2-base';

import { AppComponent } from './app/component/app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

registerLicense('ORg4AjUWIQA/Gnt2VFhhQlJBfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hSn5XdkZiWH1edHZQRGZU');

// the second parameter 'fr' is optional
registerLocaleData(localeFr, 'fr-FR');

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch(err => console.log(err));
